<script setup lang="ts">
import {useCartStore} from "@/stores/cartStore";
import {computed, ref, watch} from "vue";
import IconEdit from "@/icons/IconEdit.vue";
import IconConfirm from "@/icons/IconConfirm.vue";
const cartStore = useCartStore();
const email = ref("");
const editEmail = ref(false);
const completed = computed(() => {
  return editEmail.value ? "edited" : cartStore.customer.email ? "completed" : "";
});

watch(cartStore, (value) => {
  email.value = value.customer.email;
});

const isEmailValid = computed(() => {
  return email.value && email.value.match(/.+@.+\..+/i);
});

const handleOpenForm = () => {
  editEmail.value = true;
}

const handleSaveForm = () => {
  if(isEmailValid.value) {
    cartStore.saveEmail(email.value);
    editEmail.value = false;
  }
}
</script>
<template>
  <div :class="`contactsbox ` + completed">
    <div class="contactsbox__title">Contact Information:</div>
    <div class="contactsbox__email-box">
      <div class="contactsbox__filed-group">
        <input type="email"
               :class="`contactsbox__input input ${!isEmailValid && editEmail ? 'input--error':''}`"
               aria-label="E-mail"
               placeholder="johndoe@email.com"
               :readonly="cartStore.customer.isAuthorized || !editEmail"
               v-model="email">
        <span class="input-text input-text--error contactsbox__input-text">Fill in the E-mail field</span>
      </div>
      <template v-if="!cartStore.customer.isAuthorized">
        <button type="button" aria-label="Button success" class="Button contactsbox__Button Button--primary Button--full" @click="handleSaveForm">
          <IconConfirm /> Confirm
        </button>

        <button type="button" class="contactsbox__btn-edit btn-edit" @click="handleOpenForm">
          <IconEdit />
        </button>
      </template>
    </div>
  </div>
</template>